import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=35ed61dc&scoped=true&"
import script from "./ChatBox.vue?vue&type=script&lang=js&"
export * from "./ChatBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=35ed61dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed61dc",
  null
  
)

export default component.exports